import React from 'react';
import AOS from 'aos';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import Banner from '../../components/Banner';
import Themes from '../../components/Themes';
import Portfolios from '../../components/Portfolios';

import './_press.scss';

class PressPage extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {

    return (
      <div className="press-page">
        <Helmet>
          <title>Press | Invest as you spend</title>
          <meta name="description" content="Please get in touch with us for any media enquiries." />
        </Helmet>
        <Banner
          ctaMode={true}
          buttonMode={true}
          contactLink="hello@firststep.co"
          buttonLink="/documents/FirstStep-Presskit.pdf"
          buttonText="Download Press Kit"
          title="Press"
          tagline="For media enquiries, please contact"
        />

        <section className="app-screen invest" data-aos="fade-up" data-aos-once>
          <div className="wrapper">
            <div className="inner-wrapper">
              <div className="row align-items-center">
                <div className="col-md-6 content">
                  <div className="section-left">
                    <h2>About FirstStep</h2>
                    <p>At FirstStep we have reimagined the way we invest. The FirstStep account is designed to help you automatically reach your saving goals as you focus on the important things life.</p>
                    <p>FirstStep was founded in 2015 with a mission to make investing accessible using new technology to lower investment minimums. In December 2016 we became an ASIC registered managed investment scheme, and an experienced and dedicated team of ‘wealthtech’ professionals.</p>
                    <p>FirstStep went live on iOS and Android in January 2018 and thousands of Australians have downloaded FirstStep to reach their saving goal.</p>
                  </div>
                </div>
                <div className="col-md-6 phone">
                  <div className="section-right text-right">
                    <img src={withPrefix('images/graphics/app-screens/iphone_account_dark.png')} className="iphone-img img-fluid w-75" alt="Phone screen account graph" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



        <div class="container">
          <h2 class="text-center">Recent press</h2>
          <div class="row">

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Apr 2018</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="https://www.businessinsider.com.au/finnies-awards-australian-fintech-startups-wealth-planning-industry-2018-4" class="img-container">
                    <img class="img-fluid w-75" src={withPrefix('/images/logos/press-articles/business-insider.png')} alt="Business Insider logo" />
                  </a>
                  <p class="card-text">The Australian fintech startups taking on the wealth planning industry.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Mar 2018</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="http://www.abc.net.au/news/2018-03-05/electronic-piggybanks-for-the-tap-and-go-age/9505854" class="img-container">
                    <img class="img-fluid" src={withPrefix('/images/logos/press-articles/ABC.png')} alt="ABC logo" />
                  </a>
                  <p class="card-text">Use fintech apps to grow your wealth.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Mar 2018</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="http://www.theage.com.au/money/how-small-change-can-make-you-a-millionaire-20160316-gnl3f0" class="img-container">
                    <img class="img-fluid" src={withPrefix('/images/logos/press-articles/the-age.png')} alt="The Age logo" />
                  </a>
                  <p class="card-text">Micro-investing apps creating electronic piggybanks for the tap-and-go age.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Mar 2017</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="http://www.smh.com.au/money/how-small-change-can-make-you-a-millionaire-20160316-gnl3f0.html" class="img-container">
                    <img class="img-fluid" src={withPrefix('/images/logos/press-articles/smh.png')} alt="Sydney Morning Herald logo" />
                  </a>
                  <p class="card-text">How small change can make you a millionaire.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Mar 2017</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="http://www.startupsmart.com.au/advice/business-planning/agent-of-change-new-startup-helps-young-investors-take-first-steps/" class="img-container">
                    <img class="img-fluid" src={withPrefix('/images/logos/press-articles/startup-smart.png')} alt="Startup Smart logo" />
                  </a>
                  <p class="card-text">How small change can make you a millionaire.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="card card-media-article">
                <h5 class="card-title">Aug 2015</h5>
                <div class="card-body">
                  <a target="_blank" rel="noopener" href="http://www.startupdaily.net/2015/08/firststep-wants-get-millennials-investing-virtual-loose-change-faces-competition-acorns/" class="img-container">
                    <img class="img-fluid" src={withPrefix('/images/logos/press-articles/startup-daily.png')} alt="Startup Daily logo" />
                  </a>
                  <p class="card-text">Agent of change: New startup helps young investors take first steps.</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default PressPage;


// WEBPACK FOOTER //
// ./src/pages/press/index.js